document.addEventListener('DOMContentLoaded', function () {
    $('.faqsbox-item-title').on('click', function () {
        if ($(this).next('.faqsbox-item-content').is(':hidden')) {
            $(this).addClass('slide-active');
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).removeClass('slide-active');
            $(this).attr('aria-expanded', 'false');
        }
        $(this).next('.faqsbox-item-content').slideToggle();
    });
    $('.faqsbox-item-title').on('keydown', function (e) {
        if (e.key == 'Enter' || e.key == '') {
            $(this).click();
        }
    });
});